import useCrudFilters, {
  CrudFilters,
} from "../../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { Form, Button } from "react-bootstrap";
import { EntitySelectField } from "../../../../general/fields/modules/commons/entitySelectField/entitySelectField";
import { relationSchema } from "../../../../relation/domain/models/RelationModel";
import { TruckLicencePlateSelectField } from "../../../truck/modules/commons/TruckLicencePlateSelectField";
import { ReactSelectOptionType } from "../../../../../shared/types/reactSelectType";
import {
  TableFilters,
  TableFilterInputWrapper,
  TableFiltersWrapper,
} from "../../../../general/table/modules/commons/tableFilters/tableFilters";

export const PackingSlipTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const { t } = useTranslation("common");

  const relationFilters = useCrudFilters({
    searchBy: "SearchByRootRelation",
    fields: {},
  });

  const dateSearchValue = getFilter("date", "equal") as string;
  const relationSearchValue = getFilter("relation.id", "in") as string;
  const licencesValue = getFilter("route.truck.licence", "in") as string;
  const stateSearchValue = getFilter("state", "in") as string;

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={6}>
          <label>{t("Search")}</label>
          <Form.Control
            type="date"
            placeholder={t("Search by date")}
            value={dateSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("date");
              } else {
                updateFilter("date", value, "equal");
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={6}>
          <label>{t("Relation")}</label>
          <EntitySelectField
            filters={relationFilters.filters}
            prefix="relations"
            entity="Relation"
            labelPrefix="name"
            id={"relations.id"}
            key={"relations.id"}
            name={"relations.id"}
            value={relationSearchValue}
            onChange={(option) => {
              if (option == undefined) {
                removeFilter("relation.id");
              } else {
                updateFilter(
                  "relation.id",
                  (option as { value: string }).value,
                  "in",
                );
              }
            }}
            schema={relationSchema}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={6}>
          <label>{t("Licence plates")}</label>
          <TruckLicencePlateSelectField
            onChange={(options: unknown) => {
              const selectedOptions = options as ReactSelectOptionType[];

              if (options === null || selectedOptions.length === 0) {
                removeFilter("route.truck.licence");
                return;
              }

              const selectedOptionsStringArray = selectedOptions.map(
                (option) => {
                  return option.label.replace(/-/g, "").toUpperCase();
                },
              );

              updateFilter(
                "route.truck.licence",
                selectedOptionsStringArray,
                "in",
              );
            }}
            value={licencesValue}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={6}>
          <label>{t("State")}</label>
          <Form.Control
            as="select"
            value={stateSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("state");
              } else {
                updateFilter("state", value, "in");
              }
            }}
          >
            <option value="">{t("All")}</option>
            <option value="PENDING">{t("PENDING")}</option>
            <option value="COMPLETED">{t("COMPLETED")}</option>
          </Form.Control>
        </TableFilterInputWrapper>
      </TableFilters>

      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
